import { useAxiosQuery } from 'hooks/useAxiosQuery';
import { USER_CACHE_KEY } from 'services/queryKeys';
import { GreenerUser } from 'types';

export const useGetUser = (userId: string) => {
  const { data = {} as GreenerUser, ...rest } = useAxiosQuery<GreenerUser>(
    USER_CACHE_KEY(userId!),
    `/users/${userId}/`,
    { enabled: !!userId }
  );

  return { user: data, ...rest };
};
